import React from 'react'
import Hall11Facilities from '../components/Hall11Facilities'

export default function Facilities() {
  return (<>
    <Hall11Facilities/>
  </>
    
  )
}
